import React, { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { KTSVG } from '../../../_metronic/helpers';

interface DeletecustomerProps {
  show: boolean;
  handleClose: () => void;
  deleteselectedcustomer: () => void;
  customertodelete: any;
  statedeletingcustomer: boolean;
  cannotDeletecustomer: boolean;
}

const Deletecustomer: FC<DeletecustomerProps> = ({
  show,
  handleClose,
  deleteselectedcustomer,
  customertodelete,
  statedeletingcustomer,
  cannotDeletecustomer,
}) => {
  return (
    <Modal
      className='modal fade'
      id='kt_modal_delete_customer'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={show}
      centered
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h3 className='fw-bolder'>Delete Customer
          <span className='h-10px border-gray-200 border-start mx-2'></span>
          <span className='text-muted fw-bold fs-6'>{customertodelete.customer_id}</span>
          </h3>

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={handleClose}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <div className='fv-row mb-7'>
            <div className='card bg-light'>
              {/* begin::Header */}
              <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='required card-label fw-bolder fs-5 mb-1'>Customer Details</span>
                  <span className='text-muted mt-1 fw-bold fs-7'>
                    Review customer information before deletion
                  </span>
                </h3>
              </div>
              {/* end::Header */}
              {/* begin::Body */}
              <div className='card-body py-3'>
                <div className='row'>
                  <div className='col-lg-6 fv-row mb-7'>
                    <label className='fw-bold fs-6 mb-2'>First Name</label>
                    <div>
                      <span className='text-dark fw-bold fs-6'>
                        {customertodelete.customer_firstname || 'N/A'}
                      </span>
                    </div>
                  </div>

                  <div className='col-lg-6 fv-row mb-7'>
                    <label className='fw-bold fs-6 mb-2'>Second Name</label>
                    <div>
                      <span className='text-dark fw-bold fs-6'>
                        {customertodelete.customer_secondname || 'N/A'}
                      </span>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-lg-6 fv-row mb-7'>
                    <label className='fw-bold fs-6 mb-2'>Phone Number</label>
                    <div>
                      <span className='text-dark fw-bold fs-6'>
                        {customertodelete.customer_phone_number || 'N/A'}
                      </span>
                    </div>
                  </div>

                  <div className='col-lg-6 fv-row mb-7'>
                    <label className='fw-bold fs-6 mb-2'>Email</label>
                    <div>
                      <span className='text-dark fw-bold fs-6'>
                        {customertodelete.customer_email || 'N/A'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {/* end::Body */}
            </div>
          </div>

          {/* Warning message */}
          {cannotDeletecustomer && (
            <div className='fv-row mb-7'>
              <div className='alert alert-danger d-flex align-items-center p-5'>
                <KTSVG
                  path='/media/icons/duotune/general/gen044.svg'
                  className='svg-icon-2hx svg-icon-danger me-4'
                />
                <div className='d-flex flex-column'>
                  <span className='fw-bold fs-6'>
                    Cannot delete customer. There may be associated invoices or other dependencies.
                  </span>
                </div>
              </div>
            </div>
          )}

          <span className='required fw-bold fs-5 mb-2'>
            Are you sure you want to delete the above customer?
          </span>

        </div>
        <div className='modal-footer border-0 mt-n5'>
          <button type='button' className='btn btn-light-primary' onClick={handleClose}>
            Cancel
          </button>
          <button
            id='submit'
            type='button'
            className='btn btn-danger'
            onClick={deleteselectedcustomer}
            disabled={statedeletingcustomer || cannotDeletecustomer}
          >
            {!statedeletingcustomer && <span className='indicator-label'>Delete Customer</span>}
            {statedeletingcustomer && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export { Deletecustomer };